<template>
    <div class="login">
        <div class="row">
            <div class="col logo-header">
                <router-link to="/">
                    <img src="../assets/images/logo.png" width="111px">
                </router-link>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <h3>{{$t('login.title')}}</h3>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-8 col-sm-4">
                <b-form-group id="email-form-group"
                              class="o-label"
                              label="Email"
                              label-for="email-input">
                    <b-form-input id="email-input"
                                  class="o-form"
                                  type="text"
                                  v-model="email"
                                  required
                                  placeholder="Email">
                    </b-form-input>
                </b-form-group>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col col-8 col-sm-4">
                <b-form-group id="password-form-group"
                              class="o-label"
                              :label="$t('login.password')"
                              label-for="password-input">
                    <b-form-input id="password-input"
                                  class="o-form"
                                  type="password"
                                  v-model="password"
                                  required
                                  :placeholder="$t('login.password')">
                    </b-form-input>
                </b-form-group>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col col-8 col-sm-4">
                <b-button class="o-button"
                          v-on:click="loginUser">
                    {{$t('login.loginButton')}}
                </b-button>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col col-8 col-sm-4 links">
                <div>
                    {{$t('login.notRegistered')}}
                    <router-link to="/signup">{{$t('login.registerForFree')}}</router-link>
                </div>
                <div>
                    <router-link to="/recover-password">{{$t('login.lostPassword')}}</router-link>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="language-selection">
                    <h6>
                        <a href="#" v-on:click="switchLang('de')">Deutsch</a> |
                        <a href="#" v-on:click="switchLang('en')">English</a>
                    </h6>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import {AUTH_ACTION_LOG_IN, AUTH_NAMESPACE} from '../store/modules/auth-types'
    import i18n from '../assets/i18n/lang'

    export default {
        name: 'Login',
        metaInfo () { return { title: i18n.t('login.meta') } },
        props: {
            config: ''
        },
        data: function () {
            return {
                email: '',
                password: ''
            }
        },
        methods: {
            ...mapActions(AUTH_NAMESPACE, {
                logIn: AUTH_ACTION_LOG_IN
            }),
            loginUser () {
                this.logIn({email: this.email, password: this.password})
            },
            switchLang: function (lang) {
                this.$i18n.locale = lang
            }
        }
    }
</script>

<style lang="scss" scoped>
    .links {
        padding-top: 20px;
        white-space: nowrap;
        text-align: center;
        font-size: 10pt;
    }
</style>



// WEBPACK FOOTER //
// src/components/LoginComponent.vue